const loanDocumentsDictionary = {
  getLoanDocuments: () => "api/v1/partner/get-loan-documents",
};
export default loanDocumentsDictionary;
